"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sinhDocs = void 0;
var sinhDocs = exports.sinhDocs = {
  name: 'sinh',
  category: 'Trigonometry',
  syntax: ['sinh(x)'],
  description: 'Compute the hyperbolic sine of x in radians.',
  examples: ['sinh(0.5)'],
  seealso: ['cosh', 'tanh']
};